import login from './login'
import findPwd from './find-pwd'
import wxBind from './wx-bind'

const custom = {
  path: '',
  component: resolve => require(['../../pages/custom'], resolve),
  children: [
    login,
    findPwd,
    wxBind
  ]
}

export default custom
